import React from 'react';
import './TestimonialSection.css';

function TestimonialSection() {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      location: 'United States',
      rating: 5,
      text: 'Our safari experience with Digital Dream Safaris was absolutely incredible! The guides were knowledgeable, the accommodations were comfortable, and we saw all the Big Five.',
      image: 'https://i.pravatar.cc/150?img=47'
    },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'Australia',
      rating: 5,
      text: 'The best vacation we\'ve ever had! From climbing Kilimanjaro to relaxing in Zanzibar, every moment was perfectly planned.',
      image: 'https://i.pravatar.cc/150?img=12'
    },
    {
      id: 3,
      name: 'Emma Williams',
      location: 'United Kingdom',
      rating: 5,
      text: 'Outstanding service from start to finish! Our guide was professional, friendly, and made sure we had the best wildlife viewing opportunities.',
      image: 'https://i.pravatar.cc/150?img=45'
    },
    {
      id: 4,
      name: 'David Rodriguez',
      location: 'Spain',
      rating: 5,
      text: 'Digital Dream Safaris exceeded all our expectations. The attention to detail, safety measures, and genuine care made this trip unforgettable.',
      image: 'https://i.pravatar.cc/150?img=33'
    },
    {
      id: 5,
      name: 'Lisa Anderson',
      location: 'Canada',
      rating: 5,
      text: 'We felt safe and well-cared for throughout our entire journey. The food was excellent, the equipment was top-quality, and the crew was amazing!',
      image: 'https://i.pravatar.cc/150?img=20'
    },
    {
      id: 6,
      name: 'James Wilson',
      location: 'Germany',
      rating: 5,
      text: 'An unforgettable adventure! The Serengeti migration was a once-in-a-lifetime experience. Highly recommend Digital Dream Safaris!',
      image: 'https://i.pravatar.cc/150?img=51'
    }
  ];

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="testimonial-header">
          <h2 className="testimonial-title">What Our Clients Say</h2>
          <p className="testimonial-subtitle">
            Don't just take our word for it - hear from travelers who've experienced Tanzania with us
          </p>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="#FFD700"
                      stroke="#FFD700"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  ))}
                </div>
                
                <p className="testimonial-text">{testimonial.text}</p>
                
                <div className="testimonial-author">
                  <div className="testimonial-avatar">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      onError={(e) => {
                        e.target.src = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(testimonial.name) + '&background=445441&color=fff';
                      }}
                    />
                  </div>
                  <div className="testimonial-author-info">
                    <h4 className="testimonial-author-name">{testimonial.name}</h4>
                    <p className="testimonial-author-location">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialSection;

